export default "__VITE_ASSET__CQZy1ZZz__"